(function () {
  var STORAGE_KEY = 'wishlist_product_ids';

  function updateHeaderWishlistIcon() {
    var icon = document.querySelector('.header__icon--wishlist');
    if (!icon) return;

    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      list = [];
    }

    icon.classList.toggle('header__icon--wishlist-active', list.length > 0);
  }

  window.addEventListener('wishlist:updated', updateHeaderWishlistIcon);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderWishlistIcon);
  } else {
    updateHeaderWishlistIcon();
  }
})();
